import Vue from "vue";
import Router from "vue-router";
import store from './store';
import Components from "./pages/Components.vue";
import Principal from "./pages/Principal.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import Nosotros from "./pages/example-pages/Nosotros.vue";
import Contratar from "./pages/example-pages/Contratar.vue";
import Contratar2 from "./pages/example-pages/Contratar2.vue";
import General from "./pages/example-pages/General.vue";
import Generica from "./pages/example-pages/Generica.vue";
import Cookies from "./pages/example-pages/Cookies.vue";
import Proteccion from "./pages/example-pages/Proteccion.vue";
import Terminos from "./pages/example-pages/Terminos.vue";
import Pagos from "./pages/example-pages/Pagos.vue";
import ContactUs from "./pages/example-pages/ContactUs.vue";
import Producto from "./pages/example-pages/Producto.vue";
import Sections from "./pages/Sections.vue";
import Contratar3 from "./pages/example-pages/Contratar3.vue";

Vue.use(Router);

const router = new Router({
  //mode: 'hash',
  routes: [
    /*
    {
      path: "/",
      redirect: "/principal"
    },
    */
    
    {
      path: '/',
      redirect: (to) => {
        const pago = to.query.pago ? `/` : '';
        return '/' + store.state.homepage + pago; // Asegura que redirige según el estado en Vuex
      }
    },
    
    {
      path: '/pagos',
      name: 'pagos',
      components: { default: Pagos, header: MainNavbar, footer: MainFooter },
      props: (route) => ({ datos: route.query.datos }) // Recibe y maneja parámetros
    },
    
    {
      path: "/components",
      name: "components",
      components: {default: Components, header: MainNavbar, footer: MainFooter},
      props: {
        footer: {backgroundColor: 'black'},
        header: {colorOnScroll: 65}
      }
    },
    {
      path: "/principal",
      name: "principal",
      components: {default: Principal, header: MainNavbar, footer: MainFooter},
      props: { default: route => ({ pago: route.query.pago }), header: {colorOnScroll: 500}}
    },

    {
      path: "/contact",
      name: "contact",
      components: {default: ContactUs, header: MainNavbar, footer: MainFooter},
      props: {footer: {type: 'default'}}
    },
    {
      path: "/nosotros",
      name: "nosotros",
      components: {default: Nosotros, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 300}}
    },
    {
      path: "/contratar",
      name: "contratar",
      components: {default: Contratar, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 300}}
    },
    {
      path: "/contratar2",
      name: "contratar2",
      components: {default: Contratar2, header: MainNavbar, footer: MainFooter},
      props: { default: route => ({ pago: route.query.pago }),  header: {colorOnScroll: 300} }
    },
    {
      path: "/contratar3",
      name: "contratar3",
      components: {default: Contratar3, header: MainNavbar, footer: MainFooter},
      props: { default: route => ({ pago: route.query.pago }),  header: {colorOnScroll: 300} }
    },
    {
      path: "/general/:userId",
      name: "general",
      components: {default: General, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 300}}
    },
    {
      path: "/generica/:userId",
      name: "generica",
      components: {default: Generica, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 300}}
    },
    {
      path: "/cookies",
      name: "cookies",
      components: {default: Cookies, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 300}}
    },
    {
      path: "/proteccion",
      name: "proteccion",
      components: {default: Proteccion, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 300}}
    },
    {
      path: "/terminos",
      name: "terminos",
      components: {default: Terminos, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 300}}
    },
    {
      path: "/producto/:userId",
      name: "producto",
      components: {default: Producto, header: MainNavbar, footer: MainFooter},
      props: {header: {colorOnScroll: 450}}
    },
    {
      path: "/sections",
      name: "sections",
      components: {default: Sections, header: MainNavbar, footer: MainFooter},
      props: {
        footer: {backgroundColor: 'gray'},
        header: {colorOnScroll: 0}
      }
    }
    
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
});

// Hook de navegación
router.beforeEach((to, from, next) => {
  // Revisa si la ruta es la página de pagos y si tiene el parámetro requerido.
  if (to.name === 'pagos' && to.query.datos) {
    next(); // Si se accede directamente a pagos y tiene los datos, permite el acceso sin más redirecciones.
  } else if (to.name === 'pagos') {
    next('/'); // Si no tiene los datos, redirige a la página principal.
  } else {
    next(); // Para cualquier otra ruta, permite la navegación normal.
  }
});

export default router;
